import {useState} from 'react'
import {useDispatch} from 'react-redux'
import * as Yup from 'yup'
import clsx from 'clsx'
import {useFormik} from 'formik'
import {injectIntl} from 'react-intl'
import {connect} from 'react-redux'
import {login} from '../../../../redux/actions/authActions'
import * as auth from '../../../../redux/reducers/authReducer'
import {useAuth} from '../core/Auth'

const loginSchema = Yup.object().shape({
  username: Yup.string()
    // .email('Wrong email format')
    .min(3, 'Minimum 6 characters')
    .max(50, 'Maximum 50 characters')
    .required('Email is required'),
  password: Yup.string().min(3, 'Minimum 6 characters').max(50, 'Maximum 50 characters').required('Password is required'),
})

const initialValues = {
  username: '',
  password: '',
}

const Login = (props) => {
  const {errorMessage, loading} = props
  const [obscure, setObscure] = useState(true)
  const {setIsAuthenticated} = useAuth()
  const dispatch = useDispatch()

  const formik = useFormik({
    initialValues,
    validationSchema: loginSchema,
    onSubmit: async (values, {setStatus, setSubmitting}) => {
      const data = {username: values.username, password: values.password}
      await Login(data)
    },
  })

  const Login = async (data) => {
    await props
      .login(data)
      .then((response) => {
        setIsAuthenticated(response)
      })
      .catch((response) => {
        console.log('catch response', response)
      })
  }

  return (
    <form className='form w-100' onSubmit={formik.handleSubmit} noValidate id='kt_login_signin_form'>
      <div className='text-center mb-10'>
        <h1 className='text-dark mb-3'>Form Login</h1>
        {/* <h5 className='text-dark mb-3'>{process.env.REACT_APP_NAME}</h5> */}
      </div>

      {errorMessage && (
        <div className='mb-lg-8 alert alert-danger rounded-0'>
          <div className='alert-text fw-bold'>{errorMessage}</div>
        </div>
      )}

      <fieldset disabled={loading}>
        <div className='fv-row mb-10'>
          <label className='form-label fs-6 text-dark'>Username</label>
          <input
            {...formik.getFieldProps('username')}
            className={clsx(
              'form-control form-control-lg form-control-solid fw-normal rounded-0',
              {'is-invalid': formik.touched.username && formik.errors.username},
              {
                'is-valid': formik.touched.username && !formik.errors.username,
              }
            )}
            placeholder='Username'
            type='username'
            name='username'
            onKeyDown={async () => await dispatch(auth.actions.setErrorMessage(null))}
            autoComplete='off'
          />
          {formik.touched.username && formik.errors.username && (
            <div className='fv-plugins-message-container'>
              <div className='fv-help-block'>
                <span role='alert'>{formik.errors.username}</span>
              </div>
            </div>
          )}
        </div>

        <div className='fv-row mb-12'>
          <div className='d-flex justify-content-between mt-n5'>
            <div className='d-flex flex-stack mb-2'>
              <label className='form-label text-dark fs-6 mb-0'>Password</label>
            </div>
          </div>
          <div className='input-group mb-3'>
            <input
              type={`${obscure ? 'password' : 'text'}`}
              {...formik.getFieldProps('password')}
              className={clsx(
                'form-control form-control-lg form-control-solid fw-normal rounded-0',
                {
                  'is-invalid': formik.touched.password && formik.errors.password,
                },
                {
                  'is-valid': formik.touched.password && !formik.errors.password,
                }
              )}
              placeholder='Enter Password'
              onKeyDown={() => dispatch(auth.actions.setErrorMessage(null))}
              autoComplete='off'
            />
            <span className='input-group-text form-control-solid border-0' id='basic-addon2' onClick={() => setObscure(!obscure)}>
              <i className={`fa ${obscure ? 'fa-eye ' : 'fa-eye-slash'} fs-1x `}></i>
            </span>
          </div>
          {formik.touched.password && formik.errors.password && (
            <div className='fv-plugins-message-container'>
              <div className='fv-help-block'>
                <span role='alert'>{formik.errors.password}</span>
              </div>
            </div>
          )}
          {/* <div className='mt-3'>
            <Link to='/auth/forgot-password' className='link-primary fs-6 float-end'>
              Forgot Password ?
            </Link>
          </div> */}
        </div>
      </fieldset>

      <div className='text-center'>
        <button type='submit' className='btn btn-lg btn-primary w-100 mb-5 rounded-0' disabled={loading || formik.isSubmitting || !formik.isValid} id='kt_sign_in_submit'>
          {!loading && <span className='indicator-label'>Sign In</span>}
          {loading && (
            <span className='indicator-progress' style={{display: 'block'}}>
              Please wait...
              <span className='spinner-border spinner-border-sm align-middle ms-2'></span>
            </span>
          )}
        </button>
      </div>
    </form>
  )
}

const reduxState = (state) => ({
  loading: state.auth.loading,
  errorMessage: state.auth.errorMessage,
})

const mapsToProps = (dispatch) => ({
  login: (data) => dispatch(login(data)),
})

export default injectIntl(connect(reduxState, mapsToProps)(Login))
